"use client";
import React, { useState, useEffect } from 'react';
import CyberHacker from './CyberHacker';
import TechTrivia from './TechTrivia';
import GadgetMatch from './GadgetMatch';
import Overclock from './Overclock';
import Link from 'next/link';


const gamesList = [
  { id: 'cyber', component: <CyberHacker />, name: 'Cyber Hacker' },
  { id: 'trivia', component: <TechTrivia />, name: 'Tech Trivia' },
  { id: 'match', component: <GadgetMatch />, name: 'Gadget Match' },
  { id: 'overclock', component: <Overclock />, name: 'Overclock CPU' }
];

const GameWidget = () => { const siteName = typeof window !== 'undefined' ? (window.location.host.split('.')[0].toUpperCase() || 'SURGEDOME') : 'SURGEDOME';
  const [activeGame, setActiveGame] = useState(null);

  useEffect(() => {
    // Pick a random game on mount
    const randomIdx = Math.floor(Math.random() * gamesList.length);
    setActiveGame(gamesList[randomIdx]);
  }, []);

  if (!activeGame) return null;

  return (
    <div className="w-full flex flex-col gap-2">
      <div className="flex justify-between items-end border-b border-gray-900 pb-2 px-1">
        <h3 className="text-xl font-bold uppercase tracking-tight text-brand-text">{siteName} Game</h3>
        <Link href="/games" className="text-xs font-bold text-brand-muted hover:text-[var(--brand-text-hover)] hover:underline uppercase tracking-widest transition-colors">View All</Link>
      </div>
      <div className="w-full rounded-lg overflow-hidden shadow-sm bg-brand-surface">
        {activeGame.component}
      </div>
    </div>
  );
};

export default GameWidget;
